module.exports = __webpack_public_path__ + "../../../static/img/bs_ic_01.c42f819f.png";